/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApplicationDto } from '../models/ApplicationDto';
import type { ApplicationFilterResponseDto } from '../models/ApplicationFilterResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ApplicationControllerService {

    /**
     * @param from
     * @param status
     * @param limit
     * @param name
     * @param type
     * @returns ApplicationFilterResponseDto OK
     * @throws ApiError
     */
    public static listApplications(
        from?: number,
        status?: 'COMPLETED' | 'PENDING' | 'RUNNING',
        limit?: number,
        name?: string,
        type?: string,
    ): CancelablePromise<ApplicationFilterResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/applications',
            query: {
                'from': from,
                'status': status,
                'limit': limit,
                'name': name,
                'type': type,
            },
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static updateApplication(
        requestBody: ApplicationDto,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/applications',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns ApplicationDto Created
     * @throws ApiError
     */
    public static createApplication(
        requestBody: ApplicationDto,
    ): CancelablePromise<ApplicationDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/applications',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                409: `Conflict`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns ApplicationDto OK
     * @throws ApiError
     */
    public static getApplication(
        name: string,
    ): CancelablePromise<ApplicationDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/applications/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param name
     * @returns void
     * @throws ApiError
     */
    public static deleteApplication(
        name: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/applications/{name}',
            path: {
                'name': name,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
